import CCMRTrackingHeader from './CCMRTrackingHeader.component';

export default CCMRTrackingHeader;
